/*
 * Copyright (c) 2019. Nedaware SL
 */

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
/**
 * A list of filters with its values to filter by.
 * The keys of the map can be only the filter constructor or, alternatively,
 * the filter constructor and the name of the property it goes associated with.
 */
import {Filter} from "./filter-interface";
import {InternalPropertyMap} from "../basic-entity-back/basic-entity-interface/mapping-internal";

export type FilterList = FilterAndData[];

export class FilterAndData {
    private readonly _property: InternalPropertyMap | null;
    private readonly _filter: Filter;
    private readonly _data: any | any[];

    constructor(filter: Filter, data: any | any[], property: InternalPropertyMap | null = null) {
        this._property = property || null;
        this._filter = filter;
        this._data = data;
    }

    get property(): InternalPropertyMap | null {
        return this._property;
    }

    get filter(): Filter {
        return this._filter;
    }

    get data(): any | any[] {
        return this._data;
    }
}
